import _extends from "@babel/runtime/helpers/extends";
import { assertMediaTypeIs } from './assertMediaTypeIs';
import { getOrderMap } from './getOrderMap';
import { assertMediaTypePosition } from './assertMediaTypePosition';

/**
 * Default configuration for responsive state
 */
export var DEFAULT_CONFIG = {
  breakpoints: {
    xs: 767,
    sm: 1023,
    md: 1299
  },
  infinity: 'lg',
  orientation: 'portrait',
  // assume we on a phone and we hold it like everyone else
  extraFields: function extraFields() {
    return {};
  }
};

/**
 * Prepare configuration by adding infinity breakpoint and creating media order
 * @param {Object} options - User provided options
 * @returns {Object} Prepared configuration with mediaOrder
 */
export function prepareConfig(options) {
  if (options === void 0) {
    options = {};
  }
  var config = _extends({}, DEFAULT_CONFIG, options);

  // add `infinity` breakpoint for upper bound
  config.breakpoints = _extends({}, config.breakpoints);
  config.breakpoints[config.infinity] = Infinity;
  var mediaOrder = getOrderMap(config.breakpoints);
  return {
    config: config,
    mediaOrder: mediaOrder
  };
}

/**
 * Build responsive state object from mediaType and orientation
 * @param {Object} params - Build parameters
 * @param {string} params.mediaType - Current media type
 * @param {string} params.orientation - Current orientation
 * @param {Object} params.config - Configuration object
 * @param {Object} params.mediaOrder - Media order map
 * @returns {Object} Responsive state object
 */
export function buildResponsiveState(_ref) {
  var mediaType = _ref.mediaType,
    orientation = _ref.orientation,
    config = _ref.config,
    mediaOrder = _ref.mediaOrder;
  var responsiveState = {
    breakpoints: config.breakpoints,
    lessThan: assertMediaTypePosition(mediaType, mediaOrder, 'lessThan'),
    greaterThan: assertMediaTypePosition(mediaType, mediaOrder, 'greaterThan'),
    is: assertMediaTypeIs(mediaType, config.breakpoints),
    mediaType: mediaType,
    orientation: orientation
  };

  // return calculated state with extra fields
  return _extends({}, responsiveState, config.extraFields(responsiveState));
}